module.exports = __webpack_public_path__ + "img/source-of-fund.dbdfb6d0.svg";